import styles from "./PortfolioQuoteInfos.module.scss";
import React from "react";
import useFormat from "../../../util/useFormat";
import {useTranslation} from "react-i18next";
import ColoredAmount from "../../../common/ColoredAmount";
import {Link} from "react-router";
import {toggleQuoteFavorite} from "../../../api/ApiQuotes";
import {useDispatch, useSelector} from "react-redux";
import {rxUpdateQuotes, selectAllQuotes} from "../../../slices/quotesSlice";
import useNetwork from "../../../util/useNetwork";
import useProject from "../../../util/useProject";
import clsx from "clsx";
import {appConfigSelector} from "../../../slices/appSlice";

export const PortfolioQuoteInfos = ({quote, userQuote}) => {
  const {portfolioCurrency} = useSelector(appConfigSelector);
  const {formatAmount} = useFormat();
  const {t} = useTranslation("portfolio");

  return <div className={styles.toolbar}>
    <div className={clsx(styles.stat, styles.quote)}>
      <div className={styles.back}>
        <Link to="/portfolio"><span className="material-icons">arrow_back</span></Link>
      </div>

      <div className={styles.statLeft}>
        <div className={styles.statName}>{quote.name}</div>
        <div className={styles.statValue}>{quote.symbol}</div>
      </div>
    </div>

    <Stat label={t("stat_symbol_price")}>
      {formatAmount(quote.price, quote.currency)}
      {" "}
      <ColoredAmount amount={(quote.price / quote.previousClose * 100) - 100}>
        ({((quote.price > quote.previousClose ? "+" : "") + ((quote.price / quote.previousClose * 100) - 100).toFixed(2))}%)
      </ColoredAmount>
    </Stat>

    <Stat label={t("stat_symbol_quantity")}>{userQuote.quantity || 0}</Stat>
    <Stat label={t("stat_symbol_pru")}>
      {userQuote.quantity > 0 ? formatAmount(userQuote.pru, userQuote.currency) : "-"}
    </Stat>
    <Stat label={t("stat_symbol_total_cost")}>
      {userQuote.quantity > 0 ? formatAmount(userQuote.initialValue, portfolioCurrency) : "-"}
    </Stat>
    <Stat label={t("stat_symbol_total_value")}>
      {userQuote.quantity > 0 ? formatAmount(userQuote.marketValue, portfolioCurrency) : "-"}
    </Stat>
    <Stat label={t("stat_symbol_day_gains")}>
      {userQuote.quantity > 0 ? <ColoredAmount amount={userQuote.dayGains}>
        {formatAmount(userQuote.dayGains, portfolioCurrency)}
        {" "}
        ({((userQuote.dayGains > 0 ? "+" : "") + ((userQuote.marketValue / userQuote.dayOpenValue * 100) - 100).toFixed(2))}%)
      </ColoredAmount> : "-"}
    </Stat>

    <Stat label={t("stat_symbol_total_gains")}>
      {userQuote.transactions.length > 0 ? <ColoredAmount amount={userQuote.ongoingGains}>
        {formatAmount(userQuote.ongoingGains, portfolioCurrency)}

        {userQuote.quantity > 0 && <>
          {" "}
          ({((userQuote.ongoingGains > 0 ? "+" : "") + ((userQuote.marketValue / userQuote.initialValue * 100) - 100).toFixed(2))}%)
        </>}
      </ColoredAmount> : "-"}
    </Stat>
  </div>;
};

const Stat = ({label, children}) => {
  return <div className={styles.stat}>
    <div className={styles.statLeft}>
      <div className={styles.statName}>{label}</div>
      <div className={styles.statValue}>{children}</div>
    </div>
  </div>;
};

const FavoriteQuote = ({quote}) => {
  const dispatch = useDispatch();
  const {handleNetworkError} = useNetwork();
  const {runWithExpiration} = useProject();

  const existingQuote = useSelector(selectAllQuotes).find(q => q.symbol === quote.symbol);
  const isFavorite = existingQuote?.favorite;

  const doToggleQuoteFavorite = () => {
    toggleQuoteFavorite(quote.symbol)
      .then(res => dispatch(rxUpdateQuotes(res)))
      .catch(handleNetworkError);
  };


  return <div className={clsx(styles.favoriteAction, "hover-selectable", isFavorite ? styles.favorite : null)}>
    <span className="material-icons" onClick={runWithExpiration(doToggleQuoteFavorite)}>
      {isFavorite ? "star" : "star_border"}
    </span>
  </div>;
};
